import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-content">
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
        
        <Link to="/" className="logo">
          <img src="/logo.png" alt="Yamas Logo" className="nav-logo" />
        </Link>
        
        <ul className={`nav-links nav-links-left ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>HOME</Link></li>
          <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>ABOUT</Link></li>
          <li><Link to="/menu" className={location.pathname === '/menu' ? 'active' : 'underlined'}>MENU</Link></li>
        </ul>
        
        <ul className={`nav-links nav-links-right ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/gallery" className={location.pathname === '/gallery' ? 'active' : 'underlined'}>GALLERY</Link></li>
          <li><Link to="/reserve" className={location.pathname === '/reserve' ? 'active' : 'underlined'}>RESERVE</Link></li>
          <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : 'underlined'}>CONTACT</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
